export enum NotificationAutoMarkRead {
  ON_VIEW_DROPDOWN = "ON_VIEW_DROPDOWN",
  ON_QUICK_ACTION = "ON_QUICK_ACTION",
  MANUAL_ONLY = "MANUAL_ONLY",
}
